import mainScreens from "$escreens/mainScreens";
export default [
    ...mainScreens
]